import { createFileRoute, Navigate, Outlet } from '@tanstack/react-router'
import { toast } from '~components/ui/toast'
import useLogInStatus from '~hooks/use-login-status'
import { SamsungSmartThingsMetadata } from '~types/samsung.smart-things'
import { isOtpSpent } from '~utils/app/spent-otp'
import setMetadata from '~utils/app/set-metadata'

export const Route = createFileRoute('/samsung/smart-things/(guest)')({
  component: RouteComponent,
  validateSearch: (search: SamsungSmartThingsMetadata) => {
    if (
      search.stEnv &&
      search.stEnv !== 'acceptance' &&
      search.stEnv !== 'staging' &&
      search.stEnv !== 'production'
    ) {
      // @TODO: 추후에 dev.app.drtail.us 배포하게 되면 이 부분 다시 살려야함.
      // if (import.meta.env.VITE_ENV !== 'production') {
      toast.open({
        message: 'Invalid metadata: st_env is not valid',
        type: 'error',
      })
      search.stEnv = import.meta.env.VITE_ENV ?? 'acceptance'
    }
    // } else {
    //   delete search.stEnv
    // }
    return search
  },
  beforeLoad: ({ search }) => {
    search && setMetadata(search)
  },
})

function RouteComponent() {
  const isLoggedIn = useLogInStatus()
  const search = Route.useSearch()

  // DRT-6525: 아직 쓰지 않은 OTP 가 실려 왔다면 "새 세션 요청" 이므로, 기존 세션이
  // 있더라도 로그인 화면으로 내려보내 OTP 로그인이 먼저 돌게 한다(계정 전환 대응).
  //
  // 반대로 이미 소비한 OTP 는 호스트가 웹뷰를 재생성하며 진입 URL 을 그대로 다시 연
  // 경우다. 서버는 그 OTP 를 이미 지웠으므로 재시도해도 401 뿐이고, 그 사이 기존
  // 세션까지 버리면 사용자는 연동 화면에 갇힌다. 그런 OTP 는 없는 것으로 본다.
  const hasUnusedOtp = !!search.otp && !isOtpSpent(search.otp)

  if (isLoggedIn && !hasUnusedOtp) {
    return <Navigate to="/samsung/smart-things" replace />
  }

  return <Outlet />
}
